import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CREHANA_ACADEMIES_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, CREHANA_ACADEMIES_TRANSLATION_KEY, {
  ACADEMIES_TITLE: 'Conoce nuestras academias',
  LABEL_ACADEMIES: 'Nuevo'
});